import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import {
  type TranslatedValue,
  ContentFulComponents,
  SwarovskiOptikLocaleFrontend,
  type GeneralTranslation,
} from "@swo/storefront";
import React from "react";
import { ContentContainer } from "../../../../components/_shared-components/arrangement/Container";

import { css } from "@emotion/react";

import { PageHeadline } from "../../../../components/_shared-components/ui-elements/PageHeadline";
import { Spacer } from "../../../../components/_shared-components/arrangement/Space";
import { CSS_MQ } from "../../../../styles/breakpoints";
import { CSS_COLORS, CSS_SPACER_SIZES } from "../../../../styles/styles-css-variables";
import { SwarovskiButton } from "../../../../components/_shared-components/ui-elements/SwarovskiButton";
import { ComponentRenderer } from "../../../_layout-helpers/component-renderer";
import { paragraphStyles, wrapperStyles } from "../newsletter-landing-page-component";
import { FONTS } from "../../../../styles/fonts";
import { Translated } from "../../../../domain/translations/translations";
import { T } from "../../../../components/T";

export const ThankYouState: ReactTFC<{
  headline: React.ReactNode;
  components: Array<ContentFulComponents | string>;
  thankYouPageTranslations: { headline: TranslatedValue; paragraph: TranslatedValue; buttonLabel: TranslatedValue };
  generalTranslations: Translated<GeneralTranslation>;
  linkToHomepage: string;
  localeForNumberFormat: SwarovskiOptikLocaleFrontend;
}> = props => {
  return (
    <React.Fragment>
      <ContentContainer
        className={""}
        attachStyles={css`
          // provide some white background while cart state is being resolved
          // this prevents footer from jumping heavily
        `}
      >
        <PageHeadline>{props.headline}</PageHeadline>

        <hr
          css={css`
            width: 100%;
            height: 1px;
            background-color: black;
            border: none;
            margin: 0;
          `}
        />

        <Spacer size={"md"} />

        <div css={wrapperStyles}>
          <h2
            css={css`
              ${FONTS.MinervaModern500};

              color: ${CSS_COLORS.Green};
              text-align: center;
              text-transform: uppercase;

              font-size: 21px;
              letter-spacing: 0.35px;
              line-height: 26px;

              ${CSS_MQ.atLeastMd} {
                font-size: 30px;
                letter-spacing: 1.5px;
                line-height: 32px;
              }

              margin-top: ${CSS_SPACER_SIZES.lg};
              margin-bottom: ${CSS_SPACER_SIZES.lg};
            `}
          >
            <T>{props.thankYouPageTranslations.headline}</T>
          </h2>

          <p css={paragraphStyles}>
            <T>{props.thankYouPageTranslations.paragraph}</T>
          </p>

          <span
            css={css`
              margin-top: ${CSS_SPACER_SIZES.lg};
              margin-bottom: ${CSS_SPACER_SIZES.lg};
            `}
          >
            <SwarovskiButton as={"a"} isInternal={true} link={props.linkToHomepage} variant={"green"}>
              <T>{props.thankYouPageTranslations.buttonLabel}</T>
            </SwarovskiButton>
          </span>
        </div>
      </ContentContainer>

      <ComponentRenderer
        components={props.components}
        localeForNumberFormat={props.localeForNumberFormat}
        translations={props.generalTranslations}
      />

      <Spacer size={"md"} />
    </React.Fragment>
  );
};
